import { Brand600, Gray200 } from "../../styles/color";
import {
  MediaStyleProperties,
  StyledComponentProps,
} from "../../system/types/style/StyledComponentProps";
import styled from "@emotion/styled";

const MeetingRoomContentBoxFlexDirection: MediaStyleProperties = {
  pc: "row",
  tablet: "row",
  mobile: "column",
};
export const MeetingRoomContentBox = styled.div<StyledComponentProps>`
  display: flex;
  flex-direction: ${({ deviceType }) =>
    MeetingRoomContentBoxFlexDirection[deviceType]};
  align-items: stretch;
  min-height: calc(100dvh - 128px - 16px);
  max-height: calc(100dvh - 128px - 16px);
  gap: 8px;
  margin-top: 8px;
`;
